<template>
  <section>
    <template v-if="parsedConfig.title">
      <h3>
        {{parsedConfig.title}}
      </h3>
      <br/>
    </template>
    <div class="row mb-10">
      <div class="col-xs-12">
        <button class="btn btn-success pull-right" @click="exportCSVFile"><i class="fa fa-cloud-download mr-5"></i>Export</button>
      </div>
    </div>
    <template v-if="!loading">
      <span>Current Page: {{currentPage}}</span>
      <hr/>
      <b-table :fields="fields" :items="items" id="my-table" :per-page="perPage" :current-page="currentPage"></b-table>
      <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
      ></b-pagination>
    </template>
    <div class="row" v-else>
      <div class="col-xs-12">
        <i class="fa fa-spinner fa-spin fa-2x loading"></i>
      </div>
    </div>
    <div v-if="items.length === 0 && !loading" class="callout callout-info">
      <h4><i class="fa fa-exclamation-triangle mr-5"></i>Info</h4>
      <p>Es sind keine Items vorhanden</p>
    </div>
  </section>
</template>
<script>
  import Api from '@/services/Api'
  import { bus } from "../main";

  export default {
    props: ['config', 'endpoint', 'pageInfo'],
    name: 'TableReactive',
    data () {
     return {
       perPage: 20,
       currentPage: 1,
       loading: true,
       fields: [],
       items: [],
       companies: [],
       salesChannels: [],
       date: {}
     }
    },
    computed: {
      rows () {
        return this.items.length
      },
      parsedConfig () {
        return JSON.parse(this.config)
      },
      filters () {
        return {
          companies: this.companies,
          salesChannels: this.salesChannels,
          date: this.date
        }
      }
    },
    created () {
      bus.$on('updatedFilters', (data) => {
        this.companies = data.companies
        this.date = data.date
        this.salesChannels = data.salesChannels
        this.getData()
      })
    },
    beforeDestroy () {
      bus.$off('updatedFilters')
    },
    methods: {
      getCompanies () {
        let ret = []
        this.filters.companies.forEach(c => {
          ret.push(c.id)
        })
        return ret.join(',')
      },
      getSalesChannels () {
        let ret = []
        this.filters.salesChannels.forEach(c => {
          ret.push(c.value)
        })
        return ret.join(',')
      },
      getData () {
        this.loading = true
        Api().get(`${this.endpoint}?start=${this.filters.date.split('#')[0]}&end=${this.filters.date.split('#')[1]}&companyIdArr=${this.getCompanies()}&salesChannels=${this.getSalesChannels()}`)
          .then(r => {
            r.data.fields.forEach(f => {
              f.sortable = true
              this.fields.push(f)
            })
            this.items = r.data.items
            this.loading = false
          })
        .catch(error => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: 'Es gab ein Fehler'
          });
        })
      },
      convertToCSV (objArray) {
        let array = typeof objArray != 'object' ? JSON.parse(objArray) : objArray;
        let str = ''
        for (let i = 0; i < array.length; i++) {
          let line = ''
          for (let index in array[i]) {
            if (line !== '') line += ','

            line += `"${array[i][index]}"`
          }
          str += line + '\r\n'
        }
        return str
      },
      getHeaders (array) {
        let ret = {}
        array.forEach(i => {
          ret[i.key] = i.label
        })
        return ret
      },
      exportCSVFile () {
        let headers = this.getHeaders(this.fields)
        let items = JSON.stringify(this.items)
        let fileTitle = `${this.pageInfo.name.toLowerCase().split(' ').join('_')}_${this.parsedConfig.title.split(' ').join('_')}`
        items = JSON.parse(items)
        if (headers) {
          items.unshift(headers);
        }
        // Convert Object to JSON
        let jsonObject = JSON.stringify(items)
        let csv = this.convertToCSV(jsonObject)
        let exportedFilename = fileTitle + '.csv' || 'export.csv'

        let blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        if (navigator.msSaveBlob) { // IE 10+
          navigator.msSaveBlob(blob, exportedFilename)
        } else {
          let link = document.createElement("a")
          if (link.download !== undefined) { // feature detection
            // Browsers that support HTML5 download attribute
            let url = URL.createObjectURL(blob);
            link.setAttribute("href", url)
            link.setAttribute("download", exportedFilename)
            link.style.visibility = 'hidden'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }
      }
    },
    mounted () {
    }
  }
</script>
